import { render, staticRenderFns } from "./IvControlPanel.vue?vue&type=template&id=2c66b64b&scoped=true&"
import script from "./IvControlPanel.vue?vue&type=script&lang=js&"
export * from "./IvControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./IvControlPanel.vue?vue&type=style&index=0&id=2c66b64b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c66b64b",
  null
  
)

export default component.exports